import { SettingConst } from '@faire/web-api--source/types';

/**
 * Experiment to test the new Faire Direct signup offer system for visitors.
 * This is the second phase of the rollout which applies the new logic to the signup process.
 */
export const FAIRE_DIRECT_SIGNUP_PHASE_2_250705 =
  'FAIRE_DIRECT_SIGNUP_PHASE_2_250705' as SettingConst<
    'FAIRE_DIRECT_SIGNUP_PHASE_2_250705',
    boolean,
    'VISITOR_WEB' | 'VISITOR_PERF_APP_WEB'
  >;
